import * as angular from "angular";
import { IAxleWeightProfile } from "@interfaces/IAxleWeightProfile";
import { IAxleWeightOutOfBoundsHistory } from "@interfaces/IAxleWeightOutOfBoundsHistory";

export class AxleWeightService {
    static $inject = ["$q", "$http"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly $http: angular.IHttpService) {
    }

    getAxleWeightProfile(profileId: number): angular.IPromise<IAxleWeightProfile> {
        return this.$http({
                url: `/api/axles/profiles/${profileId}`,
                method: "GET"
            })
            .then((result: angular.IHttpPromiseCallbackArg<IAxleWeightProfile>) => {
                return result.data;
            });
    }

    getAxleWeightOutOfBoundsHistory(historyId: number): angular.IPromise<IAxleWeightOutOfBoundsHistory> {
        return this.$http({
                url: `/api/axles/histories/${historyId}`,
                method: "GET"
            })
            .then((result: angular.IHttpPromiseCallbackArg<IAxleWeightOutOfBoundsHistory>) => {
                return result.data;
            });
    }
}
